// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2AmWI","right":"styles_right__3lrIJ"};